import React from 'react'
import Button from '@material-ui/core/Button';
import { NavLink } from 'react-router-dom';
const Puz2 = () => {
    return (
        <div>
            <NavLink to='/category/Puzzels/Puzzel3'>
<Button variant="contained" color="primary" style={{float:'right', margin:'25px',marginRight:'80px'}}>Next page -&gt; </Button>
</NavLink> &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
<NavLink to='/category/Puzzels/Puzzel2'>
<Button variant="contained" color="primary" style={{float:'left', margin:'25px',marginLeft:'80px'}}>&lt;- Previous page </Button>
</NavLink>
            <article  className='container' >
    <h1 class="title">Find ages of daughters</h1>
   
    <div class="text">
        <p>Alok has three daughters. His friend Shyam wants to know the ages of his daughters. Alok gives him first
            hint.</p>
        <p>1) The product of their ages is 72.</p>
        <p>Shyam says this is not enough information Alok gives him a second hint.</p>
        <p>2) The sum of their ages is equal to my house number.</p>
        <p>Shyam goes out and look at the house number and tells “I still do not have enough information to determine
            the ages”.</p><br/>
        
       <br/>
        <p>Alok admits that Shyam can not guess and gives him the third hint</p>
        <p>3) The oldest of the girls likes strawberry ice-cream.</p>
        <p>Shyam is able to guess after the third hint. Can you guess what are the ages of three daughters?</p>
        <p>&nbsp;<br/>&nbsp;<br/>&nbsp;<br/>&nbsp;<br/>&nbsp;</p>
        <div className='output'>
        <p><strong>Answer:</strong><br/>1) Product of ages is 72</p>
        <p>Below are all possibilities to get 72 from product of three different ages:</p>
        <p>1 * 1 * 72 = 72</p>
        <p>1 * 2 * 36 = 72</p>
        <p>1 * 3 * 24 = 72</p>
        <p>1 * 4 * 18 = 72</p>
        <p>1 * 6 * 12 = 72</p>
        <p>1 * 8 * 9 = 72</p>
        <p>2 * 2 * 18 = 72</p>
        <p>2 * 3 * 12 = 72</p>
        <p>2 * 4 * 9 = 72</p>
        <p>2 * 6 * 6 = 72</p>
        <p>3 * 3 * 8 = 72</p>
        <p>3 * 4 * 6 = 72</p><br/>
       <br/>
        <p>2) Sum of the ages is given</p>
        <p>1 + 1 + 72 = 74</p>
        <p>1 + 2 + 36 = 39</p>
        <p>1 + 3 + 24 = 28</p>
        <p>1 + 4 + 18 = 23</p>
        <p>1 + 6 + 12 = 19</p>
        <p>1 + 8 + 9 = 18</p>
        <p>2 + 2 + 18 = 22</p>
        <p>2 + 3 + 12 = 17</p>
        <p>2 + 4 + 9 = 15</p>
        <p>2 + 6 + 6 = 14</p>
        <p>3 + 3 + 8 = 14</p>
        <p>3 + 4 + 6 = 13</p>
        <p>All sums are unique except 14. So the age sum must have been 14, otherwise Shyam would have guessed the ages
            from hint 2 only.</p>
        <p>So we have two possible combination to get sum 14</p>
        <p>2 + 6 + 6 = 14</p>
        <p>3 + 3 + 8 = 14</p>
        <p>3) Alok has an oldest girl (not two!!). So the ages must be 3, 3 and 8.</p>
        </div> 
        
    </div>
</article>

        </div>
    )
}

export default Puz2
